import { render, staticRenderFns } from "./commonComponents.vue?vue&type=template&id=23d9b9ba&scoped=true&"
import script from "./commonComponents.vue?vue&type=script&lang=js&"
export * from "./commonComponents.vue?vue&type=script&lang=js&"
import style0 from "./commonComponents.vue?vue&type=style&index=0&id=23d9b9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d9b9ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
